import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const OrderConfirmation = () => {
  const { orderNumber } = useParams();
  const { t } = useLang();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderNumber}`).then(r => setOrder(r.data)).catch(() => {});
  }, [orderNumber]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <div className="w-20 h-20 rounded-full bg-teal/15 flex items-center justify-center mx-auto animate-fade-up">
        <CheckCircle2 className="w-10 h-10 text-teal" />
      </div>
      <h1 className="mt-6 font-heading text-3xl sm:text-4xl font-extrabold text-navy tracking-tight animate-fade-up">{t("orderConfirmed")} 🎉</h1>
      <p className="mt-3 text-navy/70">{t("thankYou")}</p>

      {order && (
        <div className="mt-8 bg-white rounded-2xl border border-navy/10 p-6 text-left space-y-4">
          <div>
            <div className="text-xs uppercase tracking-wider text-navy/50">{t("orderNumber")}</div>
            <div className="font-heading text-2xl font-bold text-navy" data-testid="confirmation-order-number">#{order.order_number}</div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-navy/50">{t("estimatedDelivery")}</div>
            <div className="font-semibold text-navy">
              {order.delivery_time === "ASAP" ? "20-40 min" : order.delivery_time}
            </div>
          </div>
          <div className="pt-3 border-t border-navy/10">
            <div className="text-xs uppercase tracking-wider text-navy/50 mb-2">Items</div>
            {order.items.map((i, idx) => (
              <div key={idx} className="flex justify-between text-sm py-1"><span>{i.qty}× {i.name}</span><span>€{(i.price * i.qty).toFixed(2)}</span></div>
            ))}
            <div className="flex justify-between font-bold text-navy mt-2 pt-2 border-t border-navy/10"><span>{t("total")}</span><span>€{order.total.toFixed(2)}</span></div>
          </div>
        </div>
      )}

      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link to={`/order-tracking/${orderNumber}`}><Button className="btn-coral" data-testid="track-order-btn">{t("trackOrder")}</Button></Link>
        <Link to="/restaurants"><Button variant="outline" className="rounded-full border-2 border-navy text-navy hover:bg-navy hover:text-white">Order again</Button></Link>
      </div>
    </div>
  );
};

export default OrderConfirmation;
